var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChapterCircleTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 429,
    viewBox: "0 0 529 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "middle-circle-two",
    d: "M264.451 427.319C382.008 427.319 477.307 332.02 477.307 214.462C477.307 96.9047 382.008 1.60547 264.451 1.60547C146.893 1.60547 51.5938 96.9047 51.5938 214.462C51.5938 332.02 146.893 427.319 264.451 427.319Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "triangle",
    d: "M477.307 190.766L501.002 214.461L477.307 238.157",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "triangle",
    d: "M51.5939 190.766L27.8984 214.461L51.5939 238.157",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "large-triangle-circle-two",
    d: "M95.4227 120.035L1 214.458L95.4227 308.881",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "large-triangle-circle-two",
    d: "M433.449 120.012L527.901 214.463L433.449 308.915",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "outer-circle-two",
    d: "M488.092 254.283C473.889 334.718 417.35 400.577 342.271 427.934V391.702C410.414 361.731 457.977 293.66 457.977 214.474C457.977 135.289 410.414 67.1893 342.271 37.2468V1C417.35 28.3575 473.889 94.2164 488.092 174.652",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "outer-circle-two",
    d: "M40.823 174.636C55.0259 94.2007 111.579 28.3848 186.629 1.02734V37.2455C118.487 67.1879 70.9521 135.258 70.9521 214.473C70.9521 293.688 118.501 361.744 186.629 391.701V427.919C111.579 400.561 55.0115 334.731 40.8086 254.281",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M355.268 385.383V407.441",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M173.633 385.383V407.441",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M355.268 43.5427V21.4844",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M173.633 43.5427V21.4844",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterCircleTwo);
export default __webpack_public_path__ + "static/media/chapter-circle-two.e11e5ac9f496244e7091930b2a9c6fb7.svg";
export { ForwardRef as ReactComponent };